export const hero = {
  title: 'Direct import of gym equipment',
  subtitle: 'Made to order',
  button: 'View Products'
};

export const product = {
  specs: 'Specs',
  weight: 'Weight',
  volume: 'Volume',
  onRequest: 'On Request'
};

export const total = {
  label: 'TOTAL VALUE',
  onRequest: 'On Request'
};

export const delivery = {
  shipping: {
    label: 'SHIPPING FORECAST',
    value: '30 Days',
    description: 'After receiving the deposit'
  },
  delivery: {
    label: 'DELIVERY FORECAST',
    value: '60 Days',
    description: 'After equipment shipment'
  },
  packaging: {
    label: 'PACKAGING',
    value: 'Plywood',
    description: 'Plywood box'
  },
  warranty: {
    label: 'WARRANTY',
    value: '1 Year',
    description: 'Free replacement parts',
    note: '(does not include shipping costs for parts)'
  },
  manufacturer: {
    label: 'MANUFACTURER',
    value: 'BRTW',
    link: 'Visit website'
  }
};

export const financial = {
  title: 'TOTAL VALUE (BRL)',
  installment1: {
    title: 'Installment 1 — Start process',
    description: '30% to start production'
  },
  installment2: {
    title: 'Installment 2 — Shipment release',
    description: 'Product payment for release'
  },
  installment3: {
    title: 'Installment 3 — Arrival at destination',
    description: 'Port or airport'
  }
};

export const considerations = {
  title: 'Proposal Considerations',
  validity: 'Proposal validity: 15 days',
  deadline: 'Shipping deadline: Equipment must be shipped within 3 months. After this period, the contract will be considered invalid.',
  observation: 'Note: As this is a direct import of 10 equipment items, any replacement or inclusion of new items will result in recalculation of values.',
  assembly: 'Assembly and technical maintenance: Not included (buyer\'s responsibility).'
};

export const actions = {
  print: 'Print',
  download: 'Download PDF',
  whatsapp: 'Send via WhatsApp',
  email: 'Send via Email',
  whatsappText: 'Hello! Here is the Moviis commercial proposal:',
  emailSubject: 'Moviis Commercial Proposal',
  emailBody: 'Hello! Here is the Moviis commercial proposal:'
};

export const contact = {
  meeting: {
    title: 'Schedule a Meeting',
    button: 'Schedule Now'
  },
  email: {
    title: 'Contact Us',
    button: 'Send Email'
  }
};

export const footer = {
  description: 'Professional high-performance gym equipment.',
  equipment: {
    title: 'Equipment',
    cardio: 'Cardio',
    strength: 'Strength Training',
    functional: 'Functional'
  },
  info: {
    title: 'Information',
    catalog: 'Catalog',
    shipping: 'Shipping 30 days',
    delivery: 'Delivery 60 days',
    warranty: 'Warranty 1 year'
  },
  contactInfo: {
    title: 'Contact',
    address: 'R. Voluntários da Pátria, n.º 2468, 6th floor',
    zipcode: 'ZIP 02402-000',
    phone: '(11) 3255-2877',
    email: 'lp@moviis.com.br',
    hours: 'Monday to Friday, 08:30 to 18:00 (GMT -03:00)'
  },
  copyright: '© 2026 Moviis. All rights reserved.',
  poweredBy: 'Powered by Readdy'
};

export default {
  'hero.title': hero.title,
  'hero.subtitle': hero.subtitle,
  'hero.button': hero.button,
  'product.specs': product.specs,
  'product.weight': product.weight,
  'product.volume': product.volume,
  'total.label': total.label
};